
export class RfCodeCreateRequest {
    rfCodes: string[];
    username: string;

    /**
     * 
     * @param rfCodes 
     * @param username 
     */
    constructor(rfCodes: string[], username: string) {
        this.rfCodes = rfCodes;
        this.username = username;
    }
}